var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"existing-modal"},[_c('a-modal',{style:({ top: '40px' }),attrs:{"title":"Skapa Grupp","visible":_vm.visible,"cancelText":"Avbryt","width":400},on:{"ok":_vm.ModalOk,"cancel":_vm.ModalCancel}},[_c('a-input',{ref:"input",attrs:{"placeholder":"Ange namn"},on:{"change":_vm.change}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }